function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconRubles = function SvgIconRubles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.70065 6.98366H4.41732V5.56033C4.41732 5.51508 4.41735 5.48814 4.4179 5.46783C4.41826 5.45495 4.41874 5.44935 4.41887 5.448C4.42701 5.39868 4.46567 5.36002 4.51499 5.35188C4.51634 5.35175 4.52194 5.35127 4.53482 5.35091C4.55513 5.35036 4.58207 5.35033 4.62732 5.35033H5.70065C6.15168 5.35033 6.51732 5.71596 6.51732 6.16699C6.51732 6.61803 6.15168 6.98366 5.70065 6.98366Z",
    fill: "#3756FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66732 7.33366C9.66732 9.91099 7.57798 12.0003 5.00065 12.0003C2.42332 12.0003 0.333984 9.91099 0.333984 7.33366C0.333984 4.75633 2.42332 2.66699 5.00065 2.66699C7.57798 2.66699 9.66732 4.75633 9.66732 7.33366ZM3.25065 8.26699C3.25065 8.07369 3.40735 7.91699 3.60065 7.91699H3.71732V7.68366H3.60065C3.40735 7.68366 3.25065 7.52696 3.25065 7.33366C3.25065 7.14036 3.40735 6.98366 3.60065 6.98366H3.71732L3.7173 5.54236C3.71722 5.47445 3.71714 5.40386 3.72737 5.33924C3.78272 4.98979 4.05678 4.71573 4.40623 4.66038C4.47085 4.65015 4.54144 4.65023 4.60935 4.65031L5.70065 4.65033C6.53828 4.65033 7.21732 5.32936 7.21732 6.16699C7.21732 7.00462 6.53828 7.68366 5.70065 7.68366H4.41732V7.91699H5.00065C5.19395 7.91699 5.35065 8.07369 5.35065 8.26699C5.35065 8.46029 5.19395 8.61699 5.00065 8.61699H4.41732V9.66699C4.41732 9.86029 4.26062 10.017 4.06732 10.017C3.87402 10.017 3.71732 9.86029 3.71732 9.66699V8.61699H3.60065C3.40735 8.61699 3.25065 8.46029 3.25065 8.26699Z",
    fill: "#3756FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.149 5.93575C11.0607 5.36996 11.6678 4.35988 11.6678 3.20802C11.6678 1.43628 10.2315 0 8.45975 0C7.10735 0 5.95042 0.836845 5.47852 2.02095C7.72753 2.22066 9.57516 3.81638 10.149 5.93575Z",
    fill: "#7E92FF"
  }));
};
export default SvgIconRubles;